import { Box } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'
import { brandColors } from '../../styled/brand'

/**
 * A rounded-rect "phone" frame wrapping a screenshot: a dark outer body with a
 * clipped inner screen. Sizing/rotation/shadow vary per section, so those are
 * props; the `sx` escape hatch covers the hero's flex-based overlapping phones.
 */
const PhoneMockup = ({
  src,
  alt,
  width = 340,
  maxWidth = '100%',
  padding = 14,
  outerRadius = 48,
  innerRadius = 36,
  shadow = '0 40px 100px rgba(31,29,27,0.30)',
  transform,
  sx,
}: {
  src: string
  alt: string
  width?: number | string
  maxWidth?: number | string
  padding?: number
  outerRadius?: number
  innerRadius?: number
  shadow?: string
  transform?: string
  sx?: SxProps<Theme>
}) => (
  <Box
    sx={{
      width,
      maxWidth,
      padding: `${padding}px`,
      background: brandColors.phoneBody,
      borderRadius: `${outerRadius}px`,
      boxShadow: shadow,
      transform,
      ...sx,
    }}
  >
    <Box
      sx={{
        borderRadius: `${innerRadius}px`,
        overflow: 'hidden',
        background: '#000',
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{ width: '100%', display: 'block' }}
      />
    </Box>
  </Box>
)

export default PhoneMockup
